"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setElsContent = void 0;
function setElsContent(els, content) {
    (Array.isArray(els) ? els : [els]).forEach((el) => (el.textContent = content));
}
exports.setElsContent = setElsContent;
